import type { KsPackage } from '@shared/api';

export const RENDER_WATCH_MS = 60_000;

export function apiErr(err: unknown, fallback: string): string {
  if (err && typeof err === 'object' && 'data' in err) {
    const d = (err as { data?: unknown }).data;
    if (typeof d === 'string') return d;
    if (
      d &&
      typeof d === 'object' &&
      'error' in d &&
      typeof (d as { error?: unknown }).error === 'string'
    ) {
      return (d as { error: string }).error;
    }
  }
  return fallback;
}

export function netErr(err: unknown): string {
  if (err instanceof Error) return err.message;
  return String(err ?? 'неизвестная ошибка');
}

/**
 * Группа роутов `ks-packages` регистрируется только при
 * `OSNOVA_KS_PACKAGE_ENABLED=1`, поэтому при выключенном флаге реестр отвечает
 * 404 от самого роутера. Это и есть признак «функция выключена» — в
 * `/agents/smeta/info` флага нет (та же схема, что у ОЖР и КС-2 Прораба).
 */
export function isKsPackagesDisabled(err: unknown): boolean {
  return (err as { status?: number } | undefined)?.status === 404;
}

export function packageLabel(p: KsPackage): string {
  const contract = p.contract_no ? `дог. № ${p.contract_no}` : (p.contract_label ?? 'договор');
  return `КС-3 № ${p.ks3_no} · ${contract}`;
}
